/*
 * @Author: Teemo Ding
 * @Date: 2021-09-14 16:50:57
 * @LastEditTime: 2021-09-18 11:43:23
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/request/salesChannel/setting/domain.ts
 */
import { get, post, remove } from '@/src/tools/server';

export const request_domainsList = (salesChannelUuid: string) => {
  return get<any>(
    `/portal/salesChannelSetting/domainSetting/${salesChannelUuid}`,
    {},
  );
};

export const save_domainDetail = (data) => {
  return post<any>(
    `/portal/salesChannelSetting/domainSetting/domain`,
    data,
    {},
  );
};

export const save_certificate = (data) => {
  return post<any>(
    `/portal/salesChannelSetting/domainSetting/domain/certificate`,
    data,
    {},
  );
};

export const save_redirection = (data) => {
  return post<any>(
    `/portal/salesChannelSetting/domainSetting/customRedirection`,
    data,
    {},
  );
};

export const check_redirection = (data) => {
  return post<any>(
    `/portal/salesChannelSetting/domainSetting/customRedirection/check`,
    data,
    {
      returnWholeData: true,
      handleErrorAsResolve: true,
      multipleRequests: true,
    },
  );
};

export const get_domainDetail = (domainUuid) => {
  return get<any>(
    `/portal/salesChannelSetting/domainSetting/domain/${domainUuid}`,
    {},
  );
};

export const save_missingPageRedirection = (data) => {
  return post<any>(
    `/portal/salesChannelSetting/domainSetting/missingPageRedirection`,
    data,
    {},
  );
};

export const delete_domain = (uuid) => {
  return remove<any>(
    `/portal/salesChannelSetting/domainSetting/domain/${uuid}`,
    {},
  );
};

export const verify_domain = (uuid) => {
  return post<any>(
    `/portal/salesChannelSetting/domainSetting/domain/verify/${uuid}`,
    {},
    {},
  );
};

export const connect_domain = (uuid) => {
  return post<any>(
    `/portal/salesChannelSetting/domainSetting/domain/connect/${uuid}`,
    {},
    {},
  );
};

export const cancel_Submission = (uuid) => {
  return post<any>(
    `/portal/salesChannelSetting/domainSetting/domain/certificate/cancel/${uuid}`,
    {},
    {},
  );
};
